import PropTypes from 'prop-types';
import { FormControl, MenuItem, Grid, FormLabel, TextField } from '@material-ui/core';
import { ESTADOS_DO_BRASIL } from '../../utils/financialHelper';

const StatePicker = ({ label, value, onChange }) => {

  const handleChange = (e) => {
    onChange({ ...value, state: e.target.value })
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
      <FormLabel component="legend" style={{ minWidth: 40 }}>
        {label}
      </FormLabel>

      <FormControl variant="outlined" size="small">
        <TextField
          select
          label="UF"
          value={value?.state ?? ''}
          onChange={handleChange}
          variant="outlined"
          size="small"
          InputLabelProps={{ shrink: true }}
          fullWidth
        >
          {ESTADOS_DO_BRASIL.map(state => (
            <MenuItem key={state} value={state}>{state}</MenuItem>
          ))}
        </TextField>
      </FormControl>
    </div>
  );
};

StatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default StatePicker